import React from "react";
import { Container } from "react-bootstrap";
import ButtonText from "../components/ButtonText";
import Logo from "../images/icon-transparent.svg";
import { VectorBackground } from "../components/VectorBackground";

const RequestDemoBanner = ({ header, description, button }) => {
    if (!header && !description && !button) return null;

    return (
        <section className="request-demo-banner" id="request-demo">
            <Container>
                <div className="request-demo-banner__container">
                    <VectorBackground />
                    <div className="request-demo-banner__grid">
                        <div className="request-demo-banner__icon">
                            <Logo />
                        </div>

                        {header && (
                            <h3
                                className="request-demo-banner__header"
                                dangerouslySetInnerHTML={{
                                    __html: header,
                                }}
                            />
                        )}

                        {description && (
                            <div
                                className="request-demo-banner__description"
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        )}

                        {button && button.url && (
                            <ButtonText
                                className="request-demo-banner__button"
                                variant="small,primary"
                                url={button.url}
                                title={button.title}
                                target={button.target}
                            >
                                {button.title}
                            </ButtonText>
                        )}
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default RequestDemoBanner;
